import { Component, HostListener, Input, RendererFactory2, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { IBusinessCard } from '@interfaces';
import { TranslateService } from '@ngx-translate/core';
import { BusinessCardService, LanguageService } from '@services';
import { ApiResponse, IConfig } from '@shared';
import { ToastrService } from 'ngx-toastr';
import { environment } from '@env/environment';
@Component({
  selector: 'app-template2',
  templateUrl: './template2.component.html',
  styleUrl: './template2.component.scss',
})
export class Template2Component {
  @Input() businessCardLoader: boolean = true;
  @Input() businessCardData: IBusinessCard = {
    indexId: '',
    userId: '',
    status: '',
    templateId: '',
    userName: '',
    templateName: '',
    slogan: '',
    cardUrl: '',
    clientPhoneNumber: '',
    name: '',
    company: '',
    description: '',
    email: '',
    wpNumber: '',
    tiktokUrl: '',
    webUrl: '',
    fbUrl: '',
    instaUrl: '',
    youtubeUrl: '',
    logo: '',
    profileImage: '',
    workGallary: [],
    recommendationGallary: [],
    createdAt: '',
    updatedAt: '',
    youtubeVideoUrl: '',
    businessTitle: '',
    businessDescription: '',
    lang: '',
  };
  links: (keyof IBusinessCard)[] = ['email', 'wpNumber', 'tiktokUrl', 'fbUrl', 'instaUrl', 'youtubeUrl', 'webUrl'];
  linkCount = 0;
  // id!: string;
  isLoading = false;
  videoId!: SafeHtml;
  environment;
  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService,
    private businessCardService: BusinessCardService,
    private toast: ToastrService,
    private sanitizer: DomSanitizer,
  ) {
    this.environment = environment;
  }

  isLoding = false;

  ngOnInit(): void {
    // this.route.queryParamMap.subscribe((map: any) => {
    //   const { lang } = map.params;
    //   if (lang !== 'en') {
    //     document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    //   } else {
    //     document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
    //   }
    // });
    this.translate.use(this.businessCardData.lang);
    // this.id = this.route.snapshot.paramMap.get('businessCardId')!;
    this.getBusinessCard();
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange.businessCardData) {
      this.getBusinessCard();
    }
  }

  getBusinessCard() {
    this.businessCardData.businessDescription = this.businessCardData.businessDescription.replace(/\r?\n/g, '<br />');
    this.businessCardData.description = this.businessCardData.description.replace(/\r?\n/g, '<br />');
    this.videoId = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${this.getVideoId(this.businessCardData.youtubeVideoUrl)!} `,
    );
    this.businessCardData.workGallary = this.businessCardData.workGallary.filter((a: string) => a);
    this.businessCardData.recommendationGallary = this.businessCardData.recommendationGallary.filter((a: string) => a);
    this.links.forEach((linkName: keyof IBusinessCard) => {
      if (this.businessCardData[linkName]) {
        this.linkCount++;
      }
    });
  }

  getVideoId(url: string) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  }

  scroll(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  workGallarySlideConfig: IConfig = {
    dots: true,
    indicator: false,
    grid: true,
    target: 'workGallary',
    responsive: {
      0: {
        items: 4,
        noOfColumn: 2,
        noOfRows: 2,
        area: [],
      },
      768: {
        items: 5,
        noOfColumn: 3,
        noOfRows: 2,
        area: ['1/1/3/2'],
      },
      992: {
        items: 7,
        noOfColumn: 4,
        noOfRows: 2,
        area: ['1/1/3/2'],
      },
    },
  };

  recommendationGallarySlideConfig: IConfig = {
    dots: true,
    indicator: false,
    grid: true,
    target: 'recommendationGallaryCarasoul',
    responsive: {
      0: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      },
    },
  };

  getWhatsAppLink() {
    return this.businessCardData.wpNumber
      ? `https://api.whatsapp.com/send?phone=${this.businessCardData.wpNumber}`
      : `https://api.whatsapp.com/send?phone=${this.businessCardData.clientPhoneNumber}`;
  }
}
